// extracted by mini-css-extract-plugin
export var paragraph = "contact-module--paragraph--MGA1-";
export var email = "contact-module--email--BuS1t";
export var icon = "contact-module--icon--igqo7";
export var section = "contact-module--section--WZySc";
export var socialIcon = "contact-module--socialIcon--U0whQ";